import React, { useState } from 'react';

function DropdownInput({ selectedOption, list, style, setOption }) {
  // const [selectedOption, setSelectedOption] = useState('Option 1');

  // const handleChange = (event) => {
  //   setSelectedOption(event.target.value);
  // };

  return (
    <div>
      <select style={style} value={selectedOption} onChange={setOption}>
        <option value="" disabled>Select an option</option>
        {list.map((item, key) => {return(
          <option key={key} value={item.id}>
              {/* {item.a3}/{item.country} - {item.city} - {item.name} */}
              {item.name}{item.iata ? ' - ' + item.iata : ''}
          </option>
        )})}
      </select>
    </div>
  );
}

export default DropdownInput;